import React from 'react';
import {Field} from 'redux-form';
import * as Form from '../forms/formFieldHelpers';

const generateYearsForDateSelection = function (startYear) {

    const currentYear = new Date().getFullYear(), years = [];

    startYear = startYear || 1960;

    let key = 1;

    while (startYear <= currentYear) {
        const obj = {};

        obj.id = "" + key;
        obj.name = "" + startYear;
        years.push(obj);
        startYear++;
        key++;
    }
    return years.reverse();
};

const months = [{"id": 1, "name": "January"},
    {"id": 2, "name": "February"},
    {"id": 3, "name": "March"},
    {"id": 4, "name": "April"},
    {"id": 5, "name": "May"},
    {"id": 6, "name": "June"},
    {"id": 7, "name": "July"},
    {"id": 8, "name": "August"},
    {"id": 9, "name": "September"},
    {"id": 10, "name": "October"},
    {"id": 11, "name": "November"},
    {"id": 12, "name": "December"}];

const years = generateYearsForDateSelection();

class DateRange extends React.Component {

    constructor() {
        super();
        this.state = {
            checked: false,
        }
    }

    componentDidMount() {
        
        const {start_date, end_date, qualification_date, noEndDate, type, typeOf} = this.props;
      if (type !== 'CREATE') {
            if (start_date && ( !end_date || end_date === undefined || end_date === null || end_date === 'Present' || end_date === '' )) {
                this.setState({checked: true})
            }
            
            if (typeOf === 'study' && (qualification_date === 'Present' || qualification_date === undefined || noEndDate === 'true' )) {
                this.setState({checked: true})
            }
        }
    }
    

    renderStartDate() {

        return (
            <div className="">
                <label>Start Date</label>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Month"
                            name="start_month"
                            placeholder="Select month..."
                            component={ Form.selectField }
                            options={
                                months.map((selection) => {
                                    return {
                                        value: selection.id,
                                        label: selection.name,
                                    }
                                })
                            }
                            clearable={ false }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Year"
                            name="start_year"
                            placeholder="Select year..."
                            component={ Form.selectField }
                            options={
                                years.map((selection) => {
                                    return {
                                        value: selection.name,
                                        label: selection.name,
                                    }
                                })
                            }
                            clearable={ false }
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderEndDate(noEndDate) {
        return (
            <div className="">
                <label>{ noEndDate ? 'Completion Date' : 'End Date' }</label>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <div className="new-field-box">
                            <Field
                                label="Month"
                                name="end_month"
                                placeholder="Select month..."
                                component={ Form.selectField }
                                options={
                                    months.map((selection) => {
                                        return {
                                            value: selection.id,
                                            label: selection.name,
                                        }
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="new-field-box">
                            <Field
                                label="Year"
                                name="end_year"
                                placeholder="Select year..."
                                component={ Form.selectField }
                                options={
                                    years.map((selection) => {
                                        return {
                                            value: selection.name,
                                            label: selection.name,
                                        }
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderCurrentCheckbox(typeOf, noEndDate) {
        return (
            <label>
                <Field
                    label={ noEndDate ? 'Ongoing Qualification' : `I currently ${typeOf} here` }
                    name={`i_still_${ typeOf }_here`}
                    component={ Form.checkboxField }
                    checked={ this.state.checked }
                    onClick={ () => {
                        this.setState({checked: !this.state.checked})
                    } }
                />
            </label>
        )
    }

    render() {
        const {typeOf, noEndDate} = this.props;

        return (
            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        { !noEndDate && this.renderStartDate() }
                        { this.renderCurrentCheckbox(typeOf, noEndDate) }
                    </div>
                    <div className="col-xs-12 col-md-6">
                        { this.state.checked ? null : this.renderEndDate(noEndDate) }
                    </div>
                </div>
            </div>
        )
    }
}

export default DateRange;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/dates/dateRange.js